import type { SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import type { PropsWithChildren, ReactElement } from 'react';
import { breakpointSmall } from '@/constants/breakpoints';

const TabSection = styled.section<{ breakpointSmallLeftRightPadding?: string }>`
display: flex;
flex-direction: column;
align-items: center;
@media (max-width: ${breakpointSmall}) {
  padding-right: ${({ breakpointSmallLeftRightPadding = '20px' }) => breakpointSmallLeftRightPadding};
  padding-left: ${({ breakpointSmallLeftRightPadding = '20px' }) => breakpointSmallLeftRightPadding};
}
`;

export type TabProps = {
  tabIndex?: number,
  tabTitle: string | ReactElement,
  breakpointSmallLeftRightPadding?: string,
  overrideCss?: SerializedStyles,
};

const Tab = ({ children, breakpointSmallLeftRightPadding, overrideCss }: PropsWithChildren<TabProps>) => (
  <TabSection
    breakpointSmallLeftRightPadding={breakpointSmallLeftRightPadding}
    css={overrideCss}
  >{children}
  </TabSection>
);

export default Tab;
